/**
 * 解析启动参数。
 *
 * 频道消息按钮里的格式是 `w_<slug>_<集号>[_<来源>]`，由服务端在门禁引导时拼出
 * （见 drama-server 的 watchParam），机器人 /start 后也会带同一份参数把用户送回原集。
 *
 * Telegram 只在 Mini App 内提供 start_param；站外用普通链接打开时走 URL 查询参数，
 * 两条路径都要支持。
 */
export interface StartTarget {
  slug: string
  episodeNumber?: number
  source?: string
}

export function parseStartParam(raw: string | undefined): StartTarget | null {
  if (!raw) return null

  // w_<slug>_<ep>[_<source>]
  if (raw.startsWith('w_')) {
    const rest = raw.slice(2)
    const parts = rest.split('_')
    // slug 自身可能含连字符但不含下划线，所以从右往左取集号
    const epIndex = parts.findIndex((p, i) => i > 0 && /^\d+$/.test(p))
    if (epIndex > 0) {
      const slug = parts.slice(0, epIndex).join('_')
      const episodeNumber = Number(parts[epIndex])
      const source = parts.slice(epIndex + 1).join('_') || undefined
      return { slug, episodeNumber, source }
    }
  }

  // 只带 slug 的简写
  if (/^[a-z0-9-]+$/i.test(raw)) return { slug: raw }
  return null
}

/** 从当前地址栏解析，供 Telegram 外打开时使用。 */
export function targetFromLocation(): StartTarget | null {
  const q = new URLSearchParams(window.location.search)
  const slug = q.get('slug')
  if (!slug) return null
  const ep = q.get('ep')
  const source = q.get('source')
  return {
    slug,
    episodeNumber: ep ? Number(ep) : undefined,
    source: source ?? undefined,
  }
}
